module.exports = __webpack_public_path__ + "static/img/industry-ls.f869ee12.png";